import { z } from 'zod';

/** `POST /voll-wallet/receipts/validate` — o OCR do legado (`expensesWalletValidateReceiptImage`)
 *  sobre um comprovante já guardado, antes de anexá-lo ao reembolso ou à nota de um gasto
 *  pendente. Só o id vai: a URL do documento o BFF monta, nunca vem do cliente. */
export const VollWalletReceiptValidationRequestSchema = z
  .object({
    walletId: z.string().trim().min(1).max(100),
    receiptId: z.string().min(1).max(64),
    /** O valor do recibo (reembolso) ou do gasto (conciliação), em reais. */
    value: z.number().positive(),
    purpose: z.enum(['refund', 'conciliation']),
    /** The colleague whose wallet the refund uses; absent = the traveler themself. */
    travelerId: z.string().min(1).max(64).optional(),
  })
  .strict();
export type VollWalletReceiptValidationRequest = z.infer<
  typeof VollWalletReceiptValidationRequestSchema
>;

/** `valid: false` traz os motivos traduzidos do legado. `unavailable` = o OCR não respondeu: o
 *  comprovante segue (falha aberta) e a tela avisa. */
export const VollWalletReceiptValidationSchema = z
  .object({
    valid: z.boolean(),
    messages: z.array(z.string()),
    unavailable: z.literal(true).optional(),
  })
  .strict();
export type VollWalletReceiptValidation = z.infer<typeof VollWalletReceiptValidationSchema>;
